<template>
  <div class="mb-4" v-if="nrePage.nreData">

    <!--#region -- Content ---->

    <div class="stage-header border-bottom mb-4">
      <!--#region Header-->
      <div class="caption-label">
        Basic Information
        <b-badge style="margin-left: 13.5px;" v-if="$attrs.isETOSELECT" variant="primary">ETO Sector SKU</b-badge>
      </div>
      <div class="row mb-4">
        <div class="col-4">
          <div class="header-col">
            <div>FTIE ID</div>
            <div><gtc-ftie :ftieId="basic_info_review.ftie_id" /></div>
          </div>
          <div class="header-col">
            <div>ETO NRE</div>
            <div>{{ basic_info_review.nre_id }}</div>
          </div>
          <div class="header-col">
            <div>Salesforce ES</div>
            <div>{{ basic_info_review.sales_force_es_no }}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Salesforce Opportunity</div>
            <gtc-opportunity :opportunityId="basic_info_review.sales_force_opty_id"
                             :opportunityName="basic_info_review.sales_force_opty" />
          </div>
          <div class="header-col">
            <div>Account Name</div>
            <div>{{ basic_info_review.account }}</div>
          </div>
          <div class="header-col">
            <div>Account Currency</div>
            <div>{{ basic_info_review.sales_force_opty_currency }}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Product</div>
            <div>{{ basic_info_review.nre_model }}</div>
          </div>
          <div class="header-col">
            <div>Customization SKU ID</div>
            <div>{{ basic_info_review.sku_id }}</div>
          </div>
        </div>
      </div>
      <div class="caption-label">Reference(Standard) SKU Price Information</div>
      <div class="row mb-4">
        <div class="col-4">
          <div class="row">
            <div class="col-auto">
              <div class="header-col">
                <div>Standard SKU ID</div>
                <div>{{ _.get(skuItem, 'sku_id', '') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>HQ Cost</div>
            <div>{{ $attrs.currencySign}} {{ _.get(skuItem, 'price_info.hq_cost', '') | comma }}</div>
          </div>
          <div class="header-col">
            <div>GRO Cost</div>
            <div>{{$attrs.currencySign}} {{ _.get(skuItem, 'price_info.gro_cost', '') | comma }}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Distributor Price</div>
            <div>{{$attrs.currencySign}} {{ _.get(skuItem, 'price_info.distributor_price', '') | comma }}</div>
          </div>
          <div class="header-col">
            <div>Reseller Price</div>
            <div>{{$attrs.currencySign}} {{ _.get(skuItem, 'price_info.reseller_price', '') | comma }}</div>
          </div>
          <div class="header-col">
            <div>MSRP</div>
            <div>{{$attrs.currencySign}} {{ _.get(skuItem, 'price_info.msrp', '') | comma }}</div>
          </div>
        </div>
      </div>

      <!--#region NEW!! ES PM NRE Remark Fields -->
      <div v-if="basic_info_review.espm_nre_remark" class="stage-body-gtc-sales-comments-and-conclusions">
        <div class="caption-label">ES PM Remarks for the NRE</div>
        <div style="margin-bottom: 15px;">
          <gtc-froala :read-only="true" v-model="basic_info_review.espm_nre_remark" />
        </div>
        <br />
      </div>
      <!--#endregion ES PM NRE Remark Fields-->
      <!--#endregion Header-->
    </div>
    <div style="margin-bottom: 6rem;">
      <div class="border-bottom pb-4 mb-4">
        <div class="row">
          <div class="col-auto" style="min-width: 60rem;">
            <!--#region NRE Estimation-->
            <div class="stage-body-nre-estimation">
              <div class="caption-label">NRE Estimation</div>
              <div>
                <div class="header-col">
                  <div>Module</div>
                  <div class="flex-fill">
                    <gtc-text-box :read-only="true" class="" v-model="nre_estimation_from_espm.module" />
                  </div>
                </div>
                <div class="header-col">
                  <div>PoC Required</div>
                  <div>
                    {{ nre_estimation_from_espm.poc_required === 'Y' ? 'Yes' : 'No' }}
                  </div>
                </div>
                <!--#region Table-->
                <div class="mt-3">
                  <table class="table nre-estimation-table table-sm">
                    <colgroup>
                      <col style="width: 1px;" />
                      <col />
                      <col style="width: 6rem;" />
                      <col style="width: 6rem;" />
                      <col style="width: 8.9rem;" />
                      <col style="width: 8.9rem;" />
                    </colgroup>
                    <thead class="text-dark thead-light">
                      <tr>
                        <th rowspan="2" class="align-middle text-center">Category</th>
                        <th rowspan="2" class="align-middle text-center">Item</th>
                        <th colspan="2" class="text-center">ES PM</th>
                        <th colspan="2" class="text-center">HQ Sales</th>
                      </tr>
                      <tr>
                        <th class="text-center">{{ $attrs.pocWordingES }}</th>
                        <th class="text-center">{{ $attrs.mpWordingES }}</th>
                        <th class="text-center">{{ $attrs.pocWordingHQ }}</th>
                        <th class="text-center">{{ $attrs.mpWordingHQ }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!--#region Labor Cost-->
                      <tr>
                        <td rowspan="2">Labor Cost</td>
                        <td>Development</td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.labor_cost.development.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.labor_cost.development.mp_cost" /></td>
                        <td rowspan="2"><gtc-number :read-only="true" v-model="nre_estimation_curr_stage.labor_cost.poc_cost" /></td>
                        <td rowspan="2"><gtc-number :read-only="true" v-model="nre_estimation_curr_stage.labor_cost.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>Verification</td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.labor_cost.verification.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.labor_cost.verification.mp_cost" /></td>
                      </tr>
                      <!--#endregion-->
                      <!--#region Test Sample-->
                      <tr>
                        <td>Test Sample</td>
                        <td>EQT Test Sample</td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.test_sample.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.test_sample.mp_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_curr_stage.test_sample.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_curr_stage.test_sample.mp_cost" /></td>
                      </tr>

                      <!--#endregion-->
                      <!--#region Job Cost-->
                      <tr>
                        <td rowspan="5">Job Cost</td>
                        <td>Tooling Fee</td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.tooling_fee.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.tooling_fee.mp_cost" /></td>
                        <td rowspan="5"><gtc-number :read-only="true" v-model="nre_estimation_curr_stage.job_cost.poc_cost" /></td>
                        <td rowspan="5"><gtc-number :read-only="true" v-model="nre_estimation_curr_stage.job_cost.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>PCB Fabrication Fee</td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.pcb_fee.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.pcb_fee.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>Test Jig / Fixture</td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.test_jig.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.test_jig.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>Outsource Fee</td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.outsource_fee.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.outsource_fee.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Others - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_from_espm.job_cost.job_cost_others.remark }}</pre>
                            </div>
                          </div>
                        </td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.job_cost_others.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.job_cost.job_cost_others.mp_cost" /></td>
                      </tr>
                      <!--#endregion-->
                      <!--#region Regulation-->
                      <tr>
                        <td rowspan="4">Regulation</td>
                        <td>
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">EMC - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_from_espm.regulation.emc.remark }}</pre>
                            </div>
                          </div>
                        </td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.regulation.emc.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.regulation.emc.mp_cost" /></td>
                        <td rowspan="4"><gtc-number :read-only="true" v-model="nre_estimation_curr_stage.regulation.regulation_others.poc_cost" /></td>
                        <td rowspan="4"><gtc-number :read-only="true" v-model="nre_estimation_curr_stage.regulation.regulation_others.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Safety - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_from_espm.regulation.safety.remark }}</pre>
                            </div>
                          </div>
                        </td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.regulation.safety.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.regulation.safety.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Environmental - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_from_espm.regulation.environment.remark }}</pre>
                            </div>
                          </div>
                        </td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.regulation.environment.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.regulation.environment.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Others - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_from_espm.regulation.regulation_others.remark }}</pre>
                            </div>
                          </div>
                        </td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.regulation.regulation_others.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.regulation.regulation_others.mp_cost" /></td>
                      </tr>
                      <!--#endregion-->
                      <!--#region Others-->
                      <tr>
                        <td colspan="2">
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Others - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_from_espm.others.remark }}</pre>
                            </div>
                          </div>
                        </td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.others.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_from_espm.others.mp_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_curr_stage.others.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_curr_stage.others.mp_cost" /></td>
                      </tr>
                      <!--#endregion-->
                    </tbody>
                    <tfoot>
                      <tr>
                        <td>Total NRE</td>
                        <td></td>
                        <td class="text-right font-weight-normal font-size-base">{{ nre_estimation_total_poc_cost | comma }}</td>
                        <td class="text-right font-weight-normal font-size-base">{{ nre_estimation_total_mp_cost | comma }}</td>
                        <td class="text-right font-weight-normal font-size-base">{{ nre_estimation_total_poc_cost_curr_stage | comma }}</td>
                        <td class="text-right font-weight-normal font-size-base">{{ nre_estimation_total_mp_cost_curr_stage | comma }}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <!--#endregion-->
              </div>
            </div>
            <!--#endregion-->
          </div>
          <div class="col">
            <!--#region Customization Proposal-->
            <div class="stage-body-customization-proposal">
              <div class="caption-label">Customization Proposal</div>
              <div>
                <gtc-froala :read-only="true" v-model="nre_estimation_from_espm.customization_proposal" />
              </div>
            </div>
            <!--#endregion-->
            <!--#region Project Proposal File-->
            <div class="stage-body-project-proposal-file mt-3">
              <div class="caption-label d-flex">
                <div>Project Proposal File</div>
              </div>
              <div>
                <b-table small thead-class="thead-light text-dark"
                         :items="proposal_files" :fields="nrePage.projectProposalFileSetting">
                  <template #cell(file_name)="data">
                    <a herf="#" class="file" @click="$emit('getFile',data.item)">{{data.item.file_name}}</a>
                  </template>
                  <template #cell(update_time)="data">
                    {{ data.item.update_time | dateTimeFormat }}
                  </template>
                </b-table>
              </div>
            </div>
            <!--#endregion-->
          </div>
        </div>
      </div>
      <!--#region Cost Per Unit Estimation-->
      <div class="stage-body-cost-per-unit-estimation border-bottom pb-4 mb-4">
        <div class="caption-label">Cost Per Unit Estimation</div>
        <div>
          <table class="table table-sm cost-per-unit-estimation-table">
            <colgroup>
              <col style="width:1px;" />
              <col style="width:6rem;" />
              <col style="width:6rem;" />
              <col style="width:8.9rem;" />
              <col style="width:8.9rem;" />
              <col />
            </colgroup>
            <thead class="text-dark thead-light">
              <tr>
                <th class="text-nowrap text-center align-middle" rowspan="2">Category</th>
                <th class="text-nowrap text-center align-middle" colspan="2">ES PM</th>
                <th class="text-nowrap text-center align-middle" colspan="2">HQ Sales</th>
                <th class="text-nowrap text-center align-middle" rowspan="2">Remark</th>
              </tr>
              <tr>
                <th class="text-nowrap text-center align-middle">{{ $attrs.pocWordingES }}</th>
                <th class="text-nowrap text-center align-middle">{{ $attrs.mpWordingES }}</th>
                <th class="text-nowrap text-center align-middle">{{ $attrs.pocWordingHQ }}</th>
                <th class="text-nowrap text-center align-middle">{{ $attrs.mpWordingHQ }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Demand Quantity</td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_from_espm.demand_quantity.poc_cost" :decimalLen="0" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_from_espm.demand_quantity.mp_cost" :decimalLen="0" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_curr_stage.demand_quantity.poc_cost" :decimalLen="0" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_curr_stage.demand_quantity.mp_cost" :decimalLen="0" /></td>
                <td><gtc-text-box :read-only="true" class="" v-model="unit_estimation_from_espm.demand_quantity.remark" /></td>
              </tr>
              <tr>
                <td>
                  <div>(A) NRE Amortization / Per unit (for MP)</div>
                  <div class="p-tab d-flex align-items-center">
                    <b-form-checkbox v-model="unit_estimation_curr_stage.nre_amortization.nre_amortization_check"
                                     :disabled="true"
                                     @change="unit_estimation_curr_stage.nre_amortization.nre_amortization_quantity = 0"
                                     value="Y" unchecked-value="N">NRE Amortization Quantity:</b-form-checkbox>

                    <gtc-number :read-only="true"
                                :decimalLen="0" class="ml-2 text-right min-w-6"
                                v-model="unit_estimation_curr_stage.nre_amortization.nre_amortization_quantity" />

                  </div>
                </td>
                <td class="text-center">–</td>
                <td><gtc-number :read-only="true" v-model="nre_amortization_cost_hq_result" /></td>
                <td class="text-center">–</td>
                <td><gtc-number :read-only="true" v-model="nre_amortization_cost_gro_result" /></td>
                <td class="px-2">–</td>
              </tr>
              <tr>
                <td>
                  <div>(B) Cost of Base unit</div>
                  <div class="p-tab d-flex align-items-center">
                    <div>Reference PN:</div>
                    <div class="ml-2">{{ unit_estimation_from_espm.cost_base_unit.remark }}</div>
                  </div>
                  <div class="p-tab d-flex align-items-center">Deduct Cost:</div>
                </td>
                <td>
                  <gtc-number :read-only="true" v-model="unit_estimation_from_espm.cost_base_unit.poc_cost" />
                  <gtc-number :read-only="true" v-model="unit_estimation_from_espm.deduct_cost.poc_cost" />
                </td>
                <td>
                  <gtc-number :read-only="true" v-model="unit_estimation_from_espm.cost_base_unit.mp_cost" />
                  <gtc-number :read-only="true" v-model="unit_estimation_from_espm.deduct_cost.mp_cost" />
                </td>
                <td>
                  <gtc-number :read-only="true" v-model="unit_estimation_curr_stage.cost_base_unit.poc_cost" />
                </td>
                <td>
                  <gtc-number :read-only="true" v-model="unit_estimation_curr_stage.cost_base_unit.mp_cost" />
                </td>

                <td>
                  <div class="d-flex">
                    <span style="color: gray; font-style: italic; margin-top: 22.6px;">* Describe the deduction if have any</span>
                  </div>
                  <div class="d-flex" style="margin-top: 2px;" v-if="unit_estimation_curr_stage.deduct_cost.remark === null">
                    <gtc-text-box :read-only="true" class="" v-model="nullValModel" />
                  </div>
                  <div class="d-flex" style="margin-top: 2px;" v-else>
                    <gtc-text-box :read-only="true" class="" v-model="unit_estimation_curr_stage.deduct_cost.remark" />
                  </div>
                </td>

              </tr>
              <tr>
                <td>(C) Additional Material Cost / Per unit</td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_from_espm.additional_material_cost.poc_cost" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_from_espm.additional_material_cost.mp_cost" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_curr_stage.additional_material_cost.poc_cost" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_curr_stage.additional_material_cost.mp_cost" /></td>
                <td><gtc-text-box :read-only="true" class="" v-model="unit_estimation_curr_stage.additional_material_cost.remark" /></td>
              </tr>
              <tr>
                <td>(D) Additional MVA Cost / Per unit</td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_from_espm.additional_mva_cost.poc_cost" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_from_espm.additional_mva_cost.mp_cost" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_curr_stage.additional_mva_cost.poc_cost" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_curr_stage.additional_mva_cost.mp_cost" /></td>
                <td><gtc-text-box :read-only="true" v-model="unit_estimation_from_espm.additional_mva_cost.remark" /></td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>Total cost/Per unit (=A+B+C+D)</td>
                <td class="text-right font-weight-normal font-size-base">{{ unit_estimation_total_hq_poc_cost | comma }}</td>
                <td class="text-right font-weight-normal font-size-base">{{ unit_estimation_total_hq_mp_cost | comma }}</td>
                <td class="text-right font-weight-normal font-size-base">{{ unit_estimation_total_gro_poc_cost | comma }}</td>
                <td class="text-right font-weight-normal font-size-base">{{ unit_estimation_total_gro_mp_cost | comma }}</td>
                <td>
                  <div>GP for MP Unit: {{ $attrs.gpMpUnit }}% , GP for POC Unit: {{ $attrs.gpPocUnit }}%</div>
                  <div v-if="unit_estimation_curr_stage.nre_amortization.nre_amortization_check==='Y'">GP for MP Unit: {{ $attrs.gpMpUnitWithNreAmortizationQuantity }}% (Incl. the NRE amortization)</div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <!--#endregion-->
      <!--#region ETO Sector SKU INFO : P/N -->
      <div v-if="$attrs.isETOSELECT" style="margin-bottom: 6rem;">
        <div class="row">
          <div class="col-auto" style="min-width: 60rem;">
            <div class="stage-body-nre-estimation">
              <div class="caption-label">ETO Sector SKU P/N and Limitations</div>
              <div>
                <div class="header-col">
                  <div>MPS P/N<span class="text-danger pl-1">*</span></div>
                  <div class="flex-fill">
                    <gtc-text-box :read-only="true" class="" v-model="basic_info_review.eto_sector_sku.eto_select_mps_pn" />
                  </div>
                </div>
                <div class="header-col">
                  <div>SHIP P/N<span class="text-danger pl-1">*</span></div>
                  <div class="flex-fill">
                    <gtc-text-box :read-only="true" class="" v-model="basic_info_review.eto_sector_sku.eto_select_ship_pn" />
                  </div>
                </div>
                <div class="border-bottom"></div>
                <div class="header-col">
                  <div>
                    Conditions & Limitations
                  </div>
                  <div>
                    <b-form-checkbox v-model="hasRemark"
                                     name="check-button"
                                     disabled
                                     switch>
                      This ETO Sector SKU <span v-if="hasRemark"><b>has</b></span>
                      <span v-else><b>has no</b></span>
                      additional conditions and limitations
                      <button class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                              v-b-tooltip.hover.right
                              title="This remark will pass to eQuote, appending in the quotation line.">
                      </button>
                    </b-form-checkbox>

                  </div>
                </div>
                <div v-if="hasRemark" class="flex-fill">

                  <b-form-textarea v-if="hasRemark"
                                   id="textarea-plaintext"
                                   class="w-100"
                                   style="background: #eee;"
                                   plaintext
                                   :value=" _.get(nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.remark', '')">
                  </b-form-textarea>
                </div>

                <div class="border-bottom"></div>
                <div class="header-col">
                  <div>Document Link</div>
                  <div class="flex-fill">
                    <div v-if="hasDocumentLink">
                      <b-link :href="safeUrl(_.get(nrePage.nreData.page_object.basic_info_review, 'eto_sector_sku.document', ''))">{{_.get(nrePage.nreData.page_object.basic_info_review, 'eto_sector_sku.document', '')}}</b-link>
                    </div>
                    <div v-else>
                      <gtc-text-box :read-only="true"
                                    class=""
                                    v-model="nullValModel" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--#endregion ETO Sector SKU INFO : P/N -->

      <!--#region Customize Quote Items-->
      <div class="stage-body-customize-quote-items border-bottom pb-4 mb-4">
        <div class="caption-label d-flex">
          <div v-if="$attrs.isETOSELECT">ETO Sector SKU Quote Items (to eQuote)</div>
          <div v-else>Customize Quote Items</div>
        </div>
        <div>
          <b-table small thead-class="thead-light text-dark"
                   :items="$attrs.quoteItemsMapping" :fields="nrePage.customizeQuoteItemsSetting"
                   tbody-tr-class="position-relative">
            <template #cell(sku_id)="data">
              <div v-if="$attrs.isETOSELECT">
                {{basic_info_review.eto_sector_sku.eto_select_ship_pn}}
              </div>
              <div v-else>
                {{ data.item.sku_id }}
              </div>
            </template>
            <template #cell(qty)="data">
              {{ data.item.qty | comma(0) }}
            </template>
            <template #cell(amortize_qty)="data">
              <div v-if="['MP', 'MP Addition Cost'].includes(data.item.quote_type)" v-for="item in data.item.details">
                <div v-if="data.item.details.length > 1 || data.item.create_function !== 'ES PM'"
                     class="position-absolute px-3 text-left text-white"
                     :class="{'bg-primary': item.create_function === createFunction,
                              'bg-gray-560': item.create_function !== createFunction}"
                     style="width: 31.5rem;">
                  {{ item.create_function }}
                </div>
                <div :class="{'pt-4':data.item.details.length > 1 || data.item.create_function !== 'ES PM'}">{{ item.amortize_qty | comma(0) }}</div>
              </div>
            </template>
            <template #cell(hq_cost)="data">
              <div v-for="item in data.item.details">
                <div :class="{'pt-4':data.item.details.length > 1 || data.item.create_function !== 'ES PM'}">{{ item.hq_cost | comma }}</div>
              </div>
            </template>
            <template #cell(gro_cost)="data">
              <div v-for="item in data.item.details">
                <div :class="{'pt-4':data.item.details.length > 1 || data.item.create_function !== 'ES PM'}">{{ item.gro_cost | comma }}</div>
              </div>
            </template>
            <template #cell(selling_price)="data">
              <div v-for="item in data.item.details">
                <div :class="{'pt-4':data.item.details.length > 1 || data.item.create_function !== 'ES PM'}">{{ item.selling_price | comma }}</div>
              </div>
            </template>
            <template #cell(quote_to_gro)="data">
              <div v-if="!$attrs.isETOSELECT" v-for="item in data.item.details">
                <div :class="{'pt-4':data.item.details.length > 1 || data.item.create_function !== 'ES PM'}">
                  <b-form-checkbox v-model="item.quote_to_gro" :disabled="true"
                                   :value="(item.quote_to_gro ==='Y' || item.quote_to_gro==='E')? 'Y' : 'T'"
                                   unchecked-value="N" class="ml-2">
                  </b-form-checkbox>
                  <!--                                    value="Y" -->
                </div>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <!--#endregion-->
      <!--#region Customize NRE/Cost Notification-->
      <div class="stage-body-rsm-comments-and-conclusions border-bottom pb-4 mb-4">
        <div class="caption-label d-flex">
          <div>Customize NRE/Cost Notification</div>
        </div>
        <div>
          <gtc-froala :read-only="true" v-model="nrePage.nreData.page_object.mail_template_exclude_regexp" class="bg-white border-0" />
        </div>
      </div>
      <!--#endregion-->
      <!--#region GTC Sales Comments and Conclusions-->
      <div class="stage-body-gtc-sales-comments-and-conclusions border-bottom pb-4 mb-4">
        <div class="caption-label d-flex">
          <div>GTC Sales Comments and Conclusions</div>
        </div>
        <div>
          <gtc-froala :read-only="true" v-model="nrePage.nreData.page_object.gtc_comment" />
        </div>
      </div>
      <!--#endregion-->
      <!--#region RSM Comments and Conclusions-->
      <div class="border-bottom pb-4 mb-4">
        <div class="caption-label d-flex">
          <div>RSM Comments and Conclusions</div>
        </div>
        <div>
          <gtc-froala :read-only="true" v-model="nrePage.nreData.page_object.rsm_comment" />
        </div>
      </div>
      <!--#endregion-->
      <!--#region Sales Director Comments and Conclusions-->
      <div class="border-bottom pb-4 mb-4">
        <div class="caption-label d-flex">
          <div>Sales Director/Manager Comments and Conclusions</div>
        </div>
        <div>
          <gtc-froala :read-only="true" v-model="nrePage.nreData.page_object.sales_director_comment" />
        </div>
      </div>
      <!--#endregion-->
      <!--#region GRO Head Comments and Conclusions-->
      <div class="stage-body-gro-head-comments-and-conclusions border-bottom pb-4 mb-4">
        <div class="caption-label d-flex">
          <div>GRO Head Comments and Conclusions</div>
        </div>
        <div>
          <div v-if="nrePage.nreData.page_object.gro_head_comment.approval === 'Completed_'">
            <div class="d-inline-block bg-primary text-white">
              <span>Conditional Approved : </span>
              <span>{{ nrePage.nreData.page_object.gro_head_comment.update_date | dateTimeFormat }}</span>
            </div>
          </div>
          <gtc-froala :read-only="true" v-model="nrePage.nreData.page_object.gro_head_comment.content" />
        </div>
      </div>
      <!--#endregion-->
      <!--#region SA Head Comments and Conclusions-->
      <div class="border-bottom pb-4 mb-4">
        <div class="caption-label d-flex">
          <div>SA Head Comments and Conclusions</div>
        </div>
        <div>
          <gtc-froala :read-only="true" v-model="nrePage.nreData.page_object.sa_head_comment" />
        </div>
      </div>
      <!--#endregion-->
      <!--#region HQ Sales Comments and Conclusions-->
      <div class="border-bottom pb-4 mb-4">
        <div class="caption-label d-flex">
          <div>HQ Sales Comments and Conclusions</div>
        </div>
        <div>
          <div class="row mx-n1">
            <div class="col-4 px-1">
              <div class="header-col">
                <div>PoC Quantity Demand<span class="text-danger pl-1">*</span></div>
                <div class="d-flex align-items-center">
                  <gtc-number :read-only="true" :decimalLen="0" v-model="final_comment.poc_quantity" class="min-w-7 max-w-7" />
                </div>
              </div>
            </div>
            <div class="col-4 px-1">
              <div class="header-col">
                <div>MP Quantity Demand<span class="text-danger pl-1">*</span></div>
                <div class="d-flex align-items-center">
                  <gtc-number :read-only="true" :decimalLen="0" v-model="final_comment.mp_quantity" class="min-w-7 max-w-7" />
                </div>
              </div>
            </div>
            <div class="col-4 px-1">
              <div class="header-col">
                <div>Confirmed NRE<span class="text-danger pl-1">*</span></div>
                <div class="d-flex align-items-center">
                  <gtc-number :read-only="true" :decimalLen="2" v-model="final_comment.confirmed_nre" class="min-w-7 max-w-7" />
                </div>
              </div>
            </div>
            <div class="col-4 px-1">
              <div class="header-col">
                <div>PoC Required Date<span class="text-danger pl-1">*</span></div>
                <div v-if="!$attrs.readOnly && !nrePage.isSubmitted" class="d-flex align-items-center">
                  <div v-if="final_comment.poc_date === null || _.trim(final_comment.poc_date) === '' "
                       class="bg-gray-150 form-control form-control-sm min-w-7 max-w-7">N/A</div>
                  <div v-else class="bg-gray-150 form-control form-control-sm min-w-7 max-w-7">{{ final_comment.poc_date | dateFormat }}</div>
                </div>
                <div v-else class="d-flex align-items-center">
                  <div v-if="final_comment.poc_date === null || _.trim(final_comment.poc_date) === '' " class="bg-gray-150 form-control form-control-sm min-w-7 max-w-7">N/A</div>
                  <div v-else class="bg-gray-150 form-control form-control-sm min-w-7 max-w-7">{{ final_comment.poc_date | dateFormat }}</div>
                </div>
              </div>
            </div>
            <div class="col-4 px-1">
              <div class="header-col">
                <div>MP FCS Date<span class="text-danger pl-1">*</span></div>
                <div v-if="!$attrs.readOnly && !nrePage.isSubmitted" class="d-flex align-items-center">
                  <div v-if="final_comment.mp_fcs_date === null || _.trim(final_comment.mp_fcs_date) === '' "
                       class="bg-gray-150 form-control form-control-sm min-w-7 max-w-7">N/A</div>
                  <div v-else class="bg-gray-150 form-control form-control-sm min-w-7 max-w-7">{{ final_comment.mp_fcs_date | dateFormat }}</div>
                </div>
                <div v-else class="d-flex align-items-center">
                  <div v-if="final_comment.mp_fcs_date !== null" class="bg-gray-150 form-control form-control-sm min-w-7 max-w-7">
                    {{ final_comment.mp_fcs_date | dateFormat }}
                  </div>
                  <div v-else class="bg-gray-150 form-control form-control-sm min-w-7 max-w-7">
                    N/A
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4 px-1">
              <div class="header-col">
                <div>Amortization Quantity<span class="text-danger pl-1">*</span></div>
                <div class="d-flex align-items-center">
                  <gtc-number :read-only="true" :decimalLen="0" v-model="final_comment.amortization_quantity" class="min-w-7 max-w-7" />
                </div>
              </div>
            </div>
          </div>
          <gtc-froala :read-only="true" v-model="final_comment.comment" />
        </div>
      </div>
      <!--#endregion-->
      <!--#region Project Kickoff Related Files Upload-->
      <div class="" v-if="nrePage.nreData.page_object.basic_info_review.sign_flow_members.ES_PM_LEADER !== 'alex.lee'">
        <div class="caption-label d-flex">
          <div>Project Kickoff Related Files Upload</div>
        </div>
        <div>
          <nre-kickoff-files ref="child_kickoff_files" :prop_readonly="$attrs.readOnly"
                             :prop_kickoff_files="_.get(nrePage.nreData.page_object, 'kickoff_files', [])"
                             :prop_basic_info="basic_info_for_kickoff_files">
          </nre-kickoff-files>
        </div>
      </div>
      <!--#endregion-->
      <!--#region NEW!! Reject Reason Section-->
      <div v-if="$attrs.showReasonSection" class="stage-body-gtc-sales-comments-and-conclusions">
        <br />
        <div class="caption-label d-flex">
          <div>
            <span class="badge badge-danger" style="font-size: 16px;margin-bottom: 5px;">ES PM Cancel Reason</span>
          </div>
        </div>
        <div>
          <gtc-froala :read-only="true" v-model="nrePage.nreData.page_object.reject_reason" />
        </div>
      </div>
      <!--#endregion-->

    </div>
    <div class="fixed-bottom d-print-none" v-if="!$attrs.readOnly && !nrePage.isSubmitted">
      <div class="row py-3 bg-gray-150 px-4 border-top border-gray-550">
        <div class="col-auto ml-auto p-0"></div>
        <div class="col-auto">
          <button type="button" class="btn btn-danger" @click="$emit('cancelNre')">Project Cancel</button>
          <button type="button" class="btn btn-primary" @click="validate() && $emit('kickOff')">Project Kickoff</button>
        </div>
      </div>
    </div>

    <!--#endregion-->

  </div>
</template>
<script>
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    data() {
      return {
        nullValModel: 'N/A'
      };
    },
    created() {
      let self = this;
    },
    computed: {
      hasRemark() {
        let self = this;
        if (_.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.remark', null) === null
          || _.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.remark', null) === 'None'
          || _.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.remark', null) === '') {
          return false
        } else {
          return true
        }
      },
      hasDocumentLink() {
        let self = this;
        if (_.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.document', null) === null
          || _.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.document', null) === 'None'
          || _.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.document', null) === '') {
          return false
        } else {
          return true
        }
      },
      pocRequired() {
        return this.nre_estimation_from_espm.poc_required === 'Y';
      },

      canWithdraw() {
        let self = this;
        let isAwaiting = self.nrePage.nreData.espm_leader_status === 'Waiting' ||
          self.nrePage.nreData.espm_leader_status === 'W';
        return isAwaiting && self.$attrs.isSubmitted && self.$attrs.readOnly;
      },

      //#region -- Alias --

      stageNumber() {
        return this.$attrs.stageNumber;
      },
      createFunction() {
        return this.$attrs.createFunction;
      },
      skuItem() {
        return this.$attrs.skuItem;
      },
      nrePage: {
        get() {
          return this.$attrs.data;
        },
        set(value) {
          this.$attrs.data = value;
        }
      },
      basic_info_review: {
        get() {
          return this.nrePage.nreData.page_object.basic_info_review;
        },
        set(value) {
          this.nrePage.nreData.page_object.basic_info_review = value;
        }
      },
      nre_estimation_from_espm: {
        get() {
          return this.nrePage.nreData.page_object.nre_estimation_from_espm;
        },
        set(value) {
          this.nrePage.nreData.page_object.nre_estimation_from_espm = value;
        }
      },
      proposal_files: {
        get() {
          return this.nrePage.nreData.page_object.proposal_files;
        },
        set(value) {
          this.nrePage.nreData.page_object.proposal_files = value;
        }
      },
      reference_files: {
        get() {
          return this.nrePage.nreData.page_object.reference_files;
        },
        set(value) {
          this.nrePage.nreData.page_object.reference_files = value;
        }
      },
      lead_time_notice: {
        get() {
          return this.nrePage.nreData.page_object.lead_time_notice;
        },
        set(value) {
          this.nrePage.nreData.page_object.lead_time_notice = value;
        }
      },
      quote_items: {
        get() {
          return this.nrePage.nreData.page_object.quote_items;
        },
        set(value) {
          this.nrePage.nreData.page_object.quote_items = value;
        }
      },
      unit_estimation_from_espm: {
        get() {
          return this.nrePage.nreData.page_object.unit_estimation_from_espm;
        },
        set(value) {
          this.nrePage.nreData.page_object.unit_estimation_from_espm = value;
        }
      },
      nre_estimation_curr_stage: {
        get() {
          return this.nrePage.nreData.page_object.nre_estimation_curr_stage;
        },
        set(value) {
          this.nrePage.nreData.page_object.nre_estimation_curr_stage = value;
        }
      },
      unit_estimation_curr_stage: {
        get() {
          return this.nrePage.nreData.page_object.unit_estimation_curr_stage;
        },
        set(value) {
          this.nrePage.nreData.page_object.unit_estimation_curr_stage = value;
        }
      },
      final_comment: {
        get() { return this.nrePage.nreData.page_object.final_comment; },
        set(value) { this.nrePage.nreData.page_object.final_comment = value; }
      },
      poc_date: {
        get() {
          try {
            let date = new Date(this.final_comment.poc_date);
            return $.datepicker.formatDate('yy-M-dd', date);
          } catch (e) {
            return '';
          }
        },
        set(value) {
          if (_.trim(value) === '') value = '';
          else {
            value = $.datepicker.formatDate('yy-mm-dd 12:00:00', $.datepicker.parseDate("yy-M-dd", value));
          }
          this.final_comment.poc_date = value;
        }
      },
      mp_fcs_date: {
        get() {
          try {
            let date = new Date(this.final_comment.mp_fcs_date);
            return $.datepicker.formatDate('yy-M-dd', date);
          } catch (e) {
            return '';
          }
        },
        set(value) {
          if (_.trim(value) === '') value = '';
          else {
            value = $.datepicker.formatDate('yy-mm-dd 12:00:00', $.datepicker.parseDate("yy-M-dd", value));
          }
          this.final_comment.mp_fcs_date = value;
        }
      },

      //#endregion
      //#region -- Price --

      jobCost() {
        return {
          poc_cost: _.sum(_.map(this.nre_estimation_from_espm.job_cost, item => { return _.get(item, 'poc_cost', 0); })),
          mp_cost: _.sum(_.map(this.nre_estimation_from_espm.job_cost, item => { return _.get(item, 'mp_cost', 0); }))
        };
      },
      regulation() {
        return {
          poc_cost: _.sum(_.map(this.nre_estimation_from_espm.regulation, item => { return _.get(item, 'poc_cost', 0); })),
          mp_cost: _.sum(_.map(this.nre_estimation_from_espm.regulation, item => { return _.get(item, 'mp_cost', 0); }))
        };
      },

      test_sample_mp_cost() {
        let self = this;

        let mp_cost_base_unit = self.unit_estimation_from_espm.cost_base_unit.mp_cost;
        let mp_cost_add_material = self.unit_estimation_from_espm.additional_material_cost.mp_cost;
        let mp_cost_add_mva = self.unit_estimation_from_espm.additional_mva_cost.mp_cost;
        let eqt_test_sample_qty = self.nre_estimation_from_espm.test_sample.eqt_sample;
        let sharing_rate_test_sample = self.nre_estimation_from_espm.test_sample.sharing_rate;
        let result = (mp_cost_base_unit + mp_cost_add_material + mp_cost_add_mva) * eqt_test_sample_qty * (sharing_rate_test_sample / 100);

        self.nre_estimation_from_espm.test_sample.mp_cost = _.round(result, 2);

        return self.nre_estimation_from_espm.test_sample.mp_cost;
      },
      nre_estimation_total_poc_cost() {
        let self = this;
        let cols = [
          self.nre_estimation_from_espm.labor_cost.development.poc_cost,
          self.nre_estimation_from_espm.labor_cost.verification.poc_cost,
          self.nre_estimation_from_espm.test_sample.poc_cost,
          self.nre_estimation_from_espm.job_cost.tooling_fee.poc_cost,
          self.nre_estimation_from_espm.job_cost.pcb_fee.poc_cost,
          self.nre_estimation_from_espm.job_cost.test_jig.poc_cost,
          self.nre_estimation_from_espm.job_cost.outsource_fee.poc_cost,
          self.nre_estimation_from_espm.job_cost.job_cost_others.poc_cost,
          self.nre_estimation_from_espm.regulation.emc.poc_cost,
          self.nre_estimation_from_espm.regulation.safety.poc_cost,
          self.nre_estimation_from_espm.regulation.environment.poc_cost,
          self.nre_estimation_from_espm.regulation.regulation_others.poc_cost,
          self.nre_estimation_from_espm.others.poc_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.nre_estimation_from_espm.total_cost.poc_cost = result;
        return result;
      },
      nre_estimation_total_mp_cost() {
        let self = this;
        let cols = [
          self.nre_estimation_from_espm.labor_cost.development.mp_cost,
          self.nre_estimation_from_espm.labor_cost.verification.mp_cost,
          self.nre_estimation_from_espm.test_sample.mp_cost,
          self.nre_estimation_from_espm.job_cost.tooling_fee.mp_cost,
          self.nre_estimation_from_espm.job_cost.pcb_fee.mp_cost,
          self.nre_estimation_from_espm.job_cost.test_jig.mp_cost,
          self.nre_estimation_from_espm.job_cost.outsource_fee.mp_cost,
          self.nre_estimation_from_espm.job_cost.job_cost_others.mp_cost,
          self.nre_estimation_from_espm.regulation.emc.mp_cost,
          self.nre_estimation_from_espm.regulation.safety.mp_cost,
          self.nre_estimation_from_espm.regulation.environment.mp_cost,
          self.nre_estimation_from_espm.regulation.regulation_others.mp_cost,
          self.nre_estimation_from_espm.others.mp_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.nre_estimation_from_espm.total_cost.mp_cost = result;
        return result;
      },

      nre_estimation_total_poc_cost_curr_stage() {
        let self = this;
        let cols = [
          self.nre_estimation_curr_stage.labor_cost.poc_cost,
          self.nre_estimation_curr_stage.test_sample.poc_cost,
          self.nre_estimation_curr_stage.job_cost.poc_cost,
          self.nre_estimation_curr_stage.regulation.regulation_others.poc_cost,
          self.nre_estimation_curr_stage.others.poc_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.nre_estimation_curr_stage.total_cost.poc_cost = result;
        return result;
      },
      nre_estimation_total_mp_cost_curr_stage() {
        let self = this;
        let cols = [
          self.nre_estimation_curr_stage.labor_cost.mp_cost,
          self.nre_estimation_curr_stage.test_sample.mp_cost,
          self.nre_estimation_curr_stage.job_cost.mp_cost,
          self.nre_estimation_curr_stage.regulation.regulation_others.mp_cost,
          self.nre_estimation_curr_stage.others.mp_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.nre_estimation_curr_stage.total_cost.mp_cost = result;
        return result;
      },

      nre_amortization_cost_hq_result() {
        let self = this;
        let mp_cost = self.nre_estimation_total_mp_cost;
        let amortization_quantity = self.unit_estimation_curr_stage.nre_amortization.nre_amortization_quantity;

        let result = 0;
        if ('Y' === self.unit_estimation_curr_stage.nre_amortization.nre_amortization_check && amortization_quantity !== 0) {
          result = _.round(mp_cost / amortization_quantity, 2);
        }

        self.unit_estimation_from_espm.nre_amortization.nre_amortization_cost = result;
        return result;
      },
      nre_amortization_cost_gro_result() {
        let self = this;
        let mp_cost = self.nre_estimation_total_mp_cost_curr_stage;
        let amortization_quantity = self.unit_estimation_curr_stage.nre_amortization.nre_amortization_quantity;

        let result = 0;
        if ('Y' === self.unit_estimation_curr_stage.nre_amortization.nre_amortization_check && amortization_quantity !== 0) {
          result = _.round(mp_cost / amortization_quantity, 2);
        }

        self.unit_estimation_curr_stage.nre_amortization.nre_amortization_cost = result;
        return result;
      },
      unit_estimation_total_hq_poc_cost() {
        let self = this;
        let cols = [
          self.unit_estimation_from_espm.cost_base_unit.poc_cost,
          self.unit_estimation_from_espm.additional_material_cost.poc_cost,
          self.unit_estimation_from_espm.additional_mva_cost.poc_cost,
          self.unit_estimation_from_espm.deduct_cost.poc_cost * -1
        ];
        let result = _.round(_.sum(cols), 2);
        self.unit_estimation_from_espm.total_cost.poc_cost = result;
        return result;
      },
      unit_estimation_total_hq_mp_cost() {
        let self = this;
        let cols = [
          self.unit_estimation_from_espm.nre_amortization.nre_amortization_cost,
          self.unit_estimation_from_espm.cost_base_unit.mp_cost,
          self.unit_estimation_from_espm.additional_material_cost.mp_cost,
          self.unit_estimation_from_espm.additional_mva_cost.mp_cost,
          self.unit_estimation_from_espm.deduct_cost.mp_cost * -1
        ];
        let result = _.round(_.sum(cols), 2);
        self.unit_estimation_from_espm.total_cost.mp_cost = result;
        return result;
      },
      unit_estimation_total_gro_poc_cost() {
        let self = this;
        let cols = [
          self.unit_estimation_curr_stage.cost_base_unit.poc_cost,
          self.unit_estimation_curr_stage.additional_material_cost.poc_cost,
          self.unit_estimation_curr_stage.additional_mva_cost.poc_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.unit_estimation_curr_stage.total_cost.poc_cost = result;
        return result;
      },
      unit_estimation_total_gro_mp_cost() {
        let self = this;
        let cols = [
          self.unit_estimation_curr_stage.nre_amortization.nre_amortization_cost,
          self.unit_estimation_curr_stage.cost_base_unit.mp_cost,
          self.unit_estimation_curr_stage.additional_material_cost.mp_cost,
          self.unit_estimation_curr_stage.additional_mva_cost.mp_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.unit_estimation_curr_stage.total_cost.mp_cost = result;
        return result;
      },
      basic_info_for_kickoff_files() {
        let self = this;
        let result = {
          login_user: _.get(self.$store, 'state.username', null),
          createBy: self.nrePage.nreData.owner,
          ftie_id: self.nrePage.nreData.page_object.basic_info_review.ftie_id,
          nre_id: self.nrePage.nreData.page_object.basic_info_review.nre_id,
          real_sku_no: self.nrePage.nreData.page_object.basic_info_review.real_sku_no,
          sku_id: self.nrePage.nreData.page_object.basic_info_review.sku_id,
        };
        return result;
      },

      //#endregion
    },
    methods: {
      validate() {
        let self = this;
        //console.log(self.$refs.child_kickoff_files.missRequiredFile);
        let pmLeaderName = self.nrePage.nreData.page_object.basic_info_review.sign_flow_members.ES_PM_LEADER;
        if (pmLeaderName ==='alex.lee') { // ISV ticket no kickoff document
          return true;
        }
        if (self.$refs.child_kickoff_files.missRequiredFile) {
          self.$message.warning('Please ensure that you upload all the required documents!', 'File Upload Remind');

          return false;
        }

        return true;
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Kickoff.vue